import React from "react";
import PropTypes from "prop-types";
import { Box, Heading, Stack, Text, VStack } from "native-base";
import { Link } from "react-router-dom";
import Image from "../image";
import { getColorFormat } from "../../utils";
import colors from "../../constants/colors";
import routes from "../../routes";

function TourCard(props) {
  const { tour, quotation } = props;

  /* NOTE const origin = useMemo(
    () =>
      tour.itinerary.find(
        (location) => !location.isReturn && location.type === "origin",
      ),
    [tour],
  ); */

  /* NOTE const minPrice = useMemo(
    () =>
      Math.min(
        ...tour.services
          .flatMap((service) => service.prices)
          .map((price) => price.cost),
      ),
    [tour.services],
  ); */

  return (
    <Box
      width="full"
      maxWidth="23%"
      marginRight="2%"
      height={350}
      marginBottom={5}
      position="relative"
      borderRadius={5}
      overflow="hidden">
      <Box width="full" height="full" position="absolute">
        <Image
          image={tour?.photos?.at(0)}
          alt={`tour #${tour.id}`}
          objectFit="cover"
        />
      </Box>
      <VStack
        flex={1}
        backgroundColor={getColorFormat(colors.black, 0.4)}
        paddingX={5}
        paddingY={6}>
        <Heading fontSize="2xl" color={colors.white}>
          {tour.name}
        </Heading>
        {/* NOTE <Text color={colors.white}>
          {moment(origin?.departureDate).format("DD")} de{" "}
          <Text textTransform="capitalize">
            {moment(origin?.departureDate).format("MMMM")}
          </Text>
        </Text>
        <Text color={colors.white} marginTop={4}>
          Operado por
        </Text>
        <Text color={colors.white}>{tour.agency.name}</Text> */}
        <VStack flex={1} justifyContent="flex-end" space={5}>
          {/* NOTE <VStack alignItems="flex-end">
            <Heading color={colors.white} fontSize="lg">
              Desde
            </Heading>
            <Heading color={colors.white} fontSize="lg">
              {formatToCurrency(minPrice)}
            </Heading>
          </VStack> */}
          <Link
            to={{
              pathname: routes.tour.replace(":id", tour.id),
              search: quotation ? `quotation=${quotation}` : "",
            }}>
            <Stack
              borderColor={colors.white}
              borderWidth={1}
              borderRadius="full"
              width="full"
              paddingY={1}
              alignItems="center">
              <Text bold color={colors.white}>
                Ver más
              </Text>
            </Stack>
          </Link>
        </VStack>
      </VStack>
    </Box>
  );
}

TourCard.propTypes = {
  tour: PropTypes.object.isRequired,
  quotation: PropTypes.string,
};

export default React.memo(TourCard);
